import PropTypes from "prop-types";
// material-ui
import { AppBar, Box, IconButton, Toolbar } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// project imports
import LogoSection from "../LogoSection";
import ProfileSection from "./ProfileSection";
import SearchSection from "./SearchSection";
// import NotificationSection from './NotificationSection';

// assets
import Bot from "../../../bot/components/Bot";
import { drawerWidth } from "../../../store/constant";
import { runTimeConfig } from "@/config";
import { Menu } from "@mui/icons-material";
import Clock from "./Clock/clock";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }: any): React.ReactElement => {
  const theme = useTheme();

  return (
    <AppBar enableColorOnDark position="fixed" color="inherit" elevation={0}>
      {/* main wrap  */}
      <Toolbar sx={{ px: 0 }} disableGutters>
        {/* //logo and hambuger section  */}
        <Box
          sx={{
            width: drawerWidth,
            display: "flex",
            [theme.breakpoints.down("md")]: {
              width: "auto"
            },
            pl: 2
          }}
        >
          <Box component="span" sx={{ display: { xs: "none", md: "block" } }}>
            <LogoSection />
          </Box>
          <IconButton color="error" onClick={handleLeftDrawerToggle} size="large">
            <Menu sx={{ width: 21, height: 21 }} />
          </IconButton>
        </Box>

        {/* searchbar, chatbot ,clock and profile wrap  */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flex: 1,
            px: 2,
            gap: 2
            // border: "2px solid black",
          }}
        >
          {/* search icon  */}
          <SearchSection />
          {/* profile,clock and Bot section */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "space-between",
              alignItems: "center"
              // border: "2px solid black",
            }}
          >
            {/* clock component section  */}
            <Clock />
            {/* notification & profile */}
            {/* <NotificationSection /> */}
            {/* <button role="button" className="askAmwise"><QuestionAnswerIcon sx={{mr:1}} /> Ask Amwise</button> */}

            {runTimeConfig.ENABLE_AMWISE === "true" ? (
              <Box>
                <Bot
                  botTitle="Ask AMWISE"
                  subTitle=" Hi, I am AMWISE, your dedicated internal Chat GPT. I will promptly address inquiries regarding our ISMS and HR policies. I will help deliver precise guidance on compliance, data security, and best practices, ensuring a seamless work environment within our organization."
                  themeColor="#d42c2b"
                  clientId={runTimeConfig.CHATWITHDOCS_BASIC_AUTH_CLIENTID ?? ""}
                  clientSecret={runTimeConfig.CHATWITHDOCS_BASIC_AUTH_CLIENTSECRET ?? ""}
                  projectId={runTimeConfig.CHATWITHDOCS_PROJECTID ?? ""}
                />
              </Box>
            ) : null}

            {/* profile icon  */}
            <ProfileSection />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
